import { Plugin, PluginKey } from 'prosemirror-state'
import { type EditorView } from 'prosemirror-view'
import { focusModeSet } from 'redux/actions/focusMode'
import store from 'redux/store'

export const FocusModePluginKey = new PluginKey('focusMode')

const KEYSTROKE_MS_DELAY = 5000
const MIN_STROKES_FOR_FOCUS_MODE = 75

export const FocusModePlugin = () => {
  let strokes = 0
  let lastKeyTime = Date.now()

  return new Plugin({
    key: FocusModePluginKey,

    props: {
      handleDOMEvents: {
        keypress: (_view: EditorView, _event: Event) => {
          const { focusMode } = store.getState()

          if (!focusMode.showFocusMode && !focusMode.focusModeDisabled) {
            const now = Date.now()

            if (now - lastKeyTime > KEYSTROKE_MS_DELAY) {
              strokes = 1
            } else {
              strokes += 1
            }

            lastKeyTime = now

            if (strokes >= MIN_STROKES_FOR_FOCUS_MODE) {
              store.dispatch(focusModeSet({ showFocusMode: true }))
            }
          }

          return false
        },
      },
    },
  })
}
